// sls 登录类型枚举
export const SLS_LOGIN_TYPE = {
  taptap: 'TapTap',
  google: 'Google',
  apple: 'Apple',
  steam: 'Steam',
  phone: 'Phone',
};

export const LOGIN_TYPE_MAP = {
  taptap: 5,
  apple: 2,
  google: 3,
  steam: 10,
  phone: 11,
  facebook: 4,
};
